export enum CatalogPageEvent {
    CATALOG_PAGE_CONTENT_DATA_INIT = 'catalogPage:content:data:init'
}
